export enum ColorScheme {
    primary = 'primary',
    secondary = 'secondary',
    tertiary = 'tertiary',
}
